import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { BaseSettings, SharedStore } from './shared.store';
import { Organization } from '../types/common.types';

@Injectable({ providedIn: 'root' })
export class SharedService {
  constructor(private http: HttpService, private sharedStore: SharedStore) {}

  initializeStore(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.get<BaseSettings>('basesettings').subscribe({
        next: (settings) => {
          this.sharedStore.base.set(settings);
          resolve();
        },
        error: (error) => reject(error),
      });

      if (this.sharedStore.user.get().isHallMonitorUser) {
        this.http.get<Organization[]>('organizations').subscribe({
          next: (organizations) => this.sharedStore.organizations.set(organizations),
          error: (error) => reject(error),
        });
      }
    });
  }
}
